/**
 * Role-based permissions configuration
 * Single source of truth for role permissions
 */

export const ROLE_PERMISSIONS = {
  owner: [
    "manage_organization",
    "manage_users",
    "manage_billing",
    "view_analytics",
    "manage_channels",
    "manage_ai_settings",
    "manage_teams",
  ],
  admin: [
    "manage_users",
    "view_analytics",
    "manage_channels",
    "manage_ai_settings",
    "manage_teams",
  ],
  supervisor: ["view_analytics", "manage_channels", "view_teams"],
  agent: ["view_chats", "send_messages"],
};

/**
 * Get permissions for a specific role
 * @param {string} role - User role
 * @returns {string[]} Array of permissions
 */
export const getRolePermissions = (role) => {
  return ROLE_PERMISSIONS[role] || [];
};

/**
 * Check if a role has a specific permission
 * @param {string} role - User role
 * @param {string} permission - Permission to check
 * @returns {boolean} True if role has permission
 */
export const hasPermission = (role, permission) => {
  return getRolePermissions(role).includes(permission);
};

/**
 * Valid roles in the system
 */
export const VALID_ROLES = Object.keys(ROLE_PERMISSIONS);

/**
 * Check if a role is valid
 * @param {string} role - Role to validate
 * @returns {boolean} True if role is valid
 */
export const isValidRole = (role) => {
  return VALID_ROLES.includes(role);
};

